import BonusModalNotificationContainer from "./bonusModalNotification-container";

const BonusModalNotification = BonusModalNotificationContainer;
export default BonusModalNotification;
